/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */

/*
 * @Description:
 * @Date: 2019-01-15 19:30:59
 */
import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import mutations from './mutations';
Vue.use(Vuex);
var modules = {};

var storeContext = require.context('@/store/modules', true, /\.js$/);

storeContext.keys().forEach(function (modulesItem) {
  modules[modulesItem.replace(/(^\.\/)|(\.js$)/g, '')] = storeContext(modulesItem).default;
});
export default new Vuex.Store({
  state: {
    isButtonActive: '',
    // 当前切换的头条资讯或者病例分享
    isXCX: false,
    // 是否再小程序中打开
    change: false,
    // 页面loding
    classifyId: {
      // 分类
      categoryName: '',
      id: ''
    },
    headerName: '医学V视界',
    vux: {
      isLoading: false
    },
    wxUserInfo: {},
    // 用户信息 用户标识 userDataStatus 0 初始化 1 绑定手机号 2 完善科室、职称、医院信息   3、认证完成
    courseVideUrl: '',
    flowerCount: 0,
    loadingCover: 0,
    // 1 home 2 zoneList 骨架图
    closeGiftBox: false,
    categoriesList: [{
      categoryName: '',
      id: ''
    }, {
      categoryName: '',
      id: ''
    }] // 学科分类

  },
  actions: actions,
  mutations: mutations,
  modules: modules
});